import MealPlansTable from './MealPlansTable';

export default MealPlansTable;
